document.addEventListener('turbolinks:load', function() {
    const toggleButton = document.getElementById('togglePassword');
    const passwordField = document.querySelector('#password');
  
    if (toggleButton && passwordField) {
      toggleButton.addEventListener('click', function() {
        if (passwordField.type === 'password') {
          passwordField.type = 'text';
          toggleButton.innerHTML = '<i class="fa fa-toggle-on fa-lg"></i>';
        } else {
          passwordField.type = 'password';
          toggleButton.innerHTML = '<i class="fa fa-toggle-off fa-lg"></i>';
        }
      });
  
      // Definir o estado inicial do botão com base na visibilidade da senha
      toggleButton.innerHTML = passwordField.type === 'password' ? '<i class="fa fa-toggle-off fa-lg"></i>' : '<i class="fas fa-toggle-on fa-lg"></i>';
    }
});
  